import gql from 'graphql-tag';

const APPOINTMENT_STATUS_CANCELED = '254';
const APPOINTMENT_STATUS_FOLLOW_UP = '1390452';

export async function getServerTime(apollo) {
  const { data: { serverTime } } = await apollo.query({
    query: gql`{ serverTime }`,
    options: { fetchPolicy: 'network-only' },
  });
  return parseInt(serverTime, 10);
}

export const isCancelStatus = status => [
  APPOINTMENT_STATUS_CANCELED,
  APPOINTMENT_STATUS_FOLLOW_UP,
].includes(status);

export function checkEffectiveDate(date, serverTime) {
  const createDate = new Date(date.replace(/-/g, '/'));
  const effectiveDate = serverTime ? new Date(serverTime) : new Date();
  effectiveDate.setDate(effectiveDate.getDate() - 90);
  return effectiveDate <= createDate;
}

export function isCancelInspection(status, date, serverTime) {
  if (!(status || date)) return false;

  return isCancelStatus(status) && checkEffectiveDate(date, serverTime);
}




// WEBPACK FOOTER //
// ./src/cancelInspection.js